import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
  type EnumeratedLiteralModel,
} from "./enumeratedLiterals";

export const ConnectionTypes = enumeratedLiterals(
  [
    "integration_microsoft",
    "integration_shopify",
    "integration_facebook_ads",
    "integration_google_adwords",
    "integration_google_analytics",
    "integration_snapchat",
    "integration_refersion",
    "integration_linkedin",
    "integration_pinterest",
    "integration_tiktok",
    "integration_amazon",
    "integration_klaviyo",
    "integration_amazon_seller",
    "integration_twitter",
    "integration_applovin",
    "integration_tatari",
    "integration_attentive",
    "integration_mntn",
    "integration_rakuten",
    "integration_trade_desk",
    "integration_vibe",
  ] as const,
  {
    getLabels: (a) =>
      ({
        [a.INTEGRATION_AMAZON]: "Amazon Ads",
        [a.INTEGRATION_AMAZON_SELLER]: "Amazon Seller",
        [a.INTEGRATION_MICROSOFT]: "Microsoft Ads",
        [a.INTEGRATION_FACEBOOK_ADS]: "Facebook Ads",
        [a.INTEGRATION_GOOGLE_ADWORDS]: "Google Ads",
        [a.INTEGRATION_GOOGLE_ANALYTICS]: "Google Analytics",
        [a.INTEGRATION_KLAVIYO]: "Klaviyo",
        [a.INTEGRATION_TIKTOK]: "TikTok Ads",
        [a.INTEGRATION_PINTEREST]: "Pinterest Ads",
        [a.INTEGRATION_LINKEDIN]: "LinkedIn Ads",
        [a.INTEGRATION_REFERSION]: "Refersion",
        [a.INTEGRATION_SNAPCHAT]: "Snapchat Ads",
        [a.INTEGRATION_SHOPIFY]: "Shopify",
        [a.INTEGRATION_TWITTER]: "Twitter",
        [a.INTEGRATION_APPLOVIN]: "AppLovin",
        [a.INTEGRATION_TATARI]: "Tatari",
        [a.INTEGRATION_ATTENTIVE]: "Attentive Mobile",
        [a.INTEGRATION_MNTN]: "MNTN",
        [a.INTEGRATION_RAKUTEN]: "Rakuten",
        [a.INTEGRATION_TRADE_DESK]: "Trade Desk",
        [a.INTEGRATION_VIBE]: "Vibe",
      } as const),
    getAttributes: (a) => ({
      [a.INTEGRATION_AMAZON]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_AMAZON_SELLER]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_MICROSOFT]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_FACEBOOK_ADS]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_GOOGLE_ADWORDS]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_GOOGLE_ANALYTICS]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_KLAVIYO]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_TIKTOK]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_PINTEREST]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_LINKEDIN]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_REFERSION]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_SNAPCHAT]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_SHOPIFY]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_TWITTER]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_APPLOVIN]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "enableMultipleAppLovinAccounts",
        accountIdFieldName: "account_id",
      },
      [a.INTEGRATION_TATARI]: {
        isCustomConnection: true,
        customConnectionType: "tatari",
        featureFlag: "tatariV1",
        attributionModelsToAdd: [
          "northbeam_custom_matchbacks",
          "northbeam_custom",
          "northbeam_custom__va",
        ],
        attributionModelsToRemove: ["northbeam_custom_matchbacks"],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_ATTENTIVE]: {
        isCustomConnection: true,
        customConnectionType: "attentive-mobile",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_MNTN]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "mntnV1",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_RAKUTEN]: {
        isCustomConnection: true,
        customConnectionType: "rakuten",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_TRADE_DESK]: {
        isCustomConnection: true,
        customConnectionType: "tradedesk",
        featureFlag: "tradedeskV1",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
      [a.INTEGRATION_VIBE]: {
        isCustomConnection: false,
        customConnectionType: "",
        featureFlag: "",
        attributionModelsToAdd: [],
        attributionModelsToRemove: [],
        supportMultipleAccountsFeatureFlag: "",
        accountIdFieldName: "",
      },
    }),
  },
);

export type ConnectionType = EnumeratedLiteralType<typeof ConnectionTypes>;
export type ConnectionTypeLabel = EnumeratedLiteralModel<
  typeof ConnectionTypes
>["label"];

export type ConnectionAccountMetadata = {
  id: string;
  name: string;
  data: Record<string, any>;
  metadata?: Record<string, any>;
};

export type IntegrationError = { error: string };
export type Integration = ConnectionAccountMetadata | { error: string };

export function isIntegrationValid(
  a: Integration,
): a is ConnectionAccountMetadata {
  return !("error" in a);
}

export enum ConnectionErrorType {
  INTERNAL_UNKNOWN,
  INTERNAL_NOT_IMPLEMENTED,
  HTTP_400_BAD_REQUEST,
  HTTP_403_ACCESS_NOT_AUTHORIZED,
  HTTP_423_TARGET_LOCKED,
  HTTP_429_RATE_LIMIT_TOO_MANY_REQUESTS,
  AMAZON_ADS_CTX_ACCOUNT_NOT_ITERABLE,
  FACEBOOK_ADS_CANNOT_READ_PROPERTIES_OF_UNDEFINED_DATA,
  GOOGLE_ADS_CUSTOMER_ACCOUNT_NOT_ENABLED,
  GOOGLE_ADS_FAILURE_INSTANCE_NO_LONGER_MANAGED,
  GOOGLE_ADS_INSUFFICIENT_AUTHENTICATION_SCOPES,
  GOOGLE_ADS_INVALID_GRANT,
  GOOGLE_ANALYTICS_INVALID_GRANT,
  MICROSOFT_ADS_ERROR_105_INVALID_CREDENTIALS,
  MICROSOFT_ADS_ERROR_124_PERSONAL_IDENTITY_MIGRATED_TO_WORK,
  TIKTOK_ADS_CANNOT_READ_PROPERTIES_OF_UNDEFINED_ACCESS_TOKEN,
  ATTENTIVE_MOBILE_INVALID_CREDENTIALS,
}

export type ConnectionIssue = {
  message: string;
  reconnectRecommended: boolean;
  connectionErrorEnum: ConnectionErrorType;
};

export interface AccountValidationInfo {
  accountIdentifier: any;
  name: string;
  connectionIssue: ConnectionIssue | null;
}

export interface ConnectionValidationResult {
  descriptiveName: string;
  connectedAccounts: AccountValidationInfo[];
  connectionLevelIssues: ConnectionIssue[];
  errorMessage?: string;
}
